import React, { useEffect, useState } from 'react';

import { Title, Wrapper, SubText, Picture } from './styled/PromptStyled';
import Column from '../Column';
import Icon from '../Icon';
import CloseButton from '../CloseButton/CloseButton';

interface PromptData {
    title?: string;
    subtext?: string;
    category?: string;
    iconName?: string;
}

function Prompt({ prompt = {} }: { prompt?: PromptData }) {
    const [showPrompt, setShowPrompt] = useState(true);

    useEffect(() => {
        setShowPrompt(true);
    }, [prompt.title]);

    if (!prompt.title) {
        return null;
    }

    if (!showPrompt) {
        return null;
    }

    function getIcon() {
        switch (prompt.category) {
            case 'after-the-x-call':
                return 'FirstCall';
            case 'morning':
                return 'Morning';
            case 'afternoon':
                return 'Afternoon';
            default:
                return 'TenthCall';
        }
    }

    return (
        <Wrapper data-testid="trainer-prompt-card">
            <Picture data-testid="trainer-prompt-icon">
                <Icon name={getIcon()} />
            </Picture>
            <Column data-testid="trainer-prompt-content">
                <Title>{prompt.title}</Title>
                <SubText>{prompt.subtext}</SubText>
            </Column>
            <CloseButton data-testid="trainer-prompt-close" $top={4} onClick={() => setShowPrompt(false)}>
                <Icon name="Cross" size={11} />
            </CloseButton>
        </Wrapper>
    );
}

Prompt.defaultProps = {
    prompt: {
        title: '',
        subtext: '',
        iconName: ''
    }
};

export default Prompt;
